import {get} from '../utils/api';

export const FETCH_LATEST_UNIT_BEGIN = 'FETCH_LATEST_UNIT_BEGIN';
export const FETCH_LATEST_UNIT_SUCCESS = 'FETCH_LATEST_UNIT_SUCCESS';
export const UPDATE_LATEST_UNIT_PAGE = 'UPDATE_LATEST_UNIT_PAGE';

export const fetchLatestUnitBegin = (page) => ({
    type: FETCH_LATEST_UNIT_BEGIN,
    payload: page
});

export const fetchLatestUnitSuccess = result => ({
    type: FETCH_LATEST_UNIT_SUCCESS,
    payload: result
});

export const updateCurrentPage = page => ({
    type: UPDATE_LATEST_UNIT_PAGE,
    payload: page
});

export function fetchLatestUnits(page) {
    return dispatch => {
        dispatch(fetchLatestUnitBegin(page));
        return get('units/latest?page=' + page)
            .then((res) => {
                dispatch(fetchLatestUnitSuccess(res));
            });
    };
}
